export default "__VITE_ASSET__Cf$h0Ss___"